module.exports = __webpack_public_path__ + "static/media/pts2.29d90a0d.jpeg";